


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { MasterModule } from '@/app/store/modules/master'

@Component({
  name: 'FilterChart',
  components: {
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) private isDisabled: boolean | undefined
  @Prop({}) private funcFilter: any | undefined
  @Prop({}) private funcClearFilter: any | undefined
  @Prop({}) private hasFilter: boolean | undefined
  @Prop({}) private onClearFilter: boolean | undefined
  // @Prop({}) public linkExport
  //   @Prop({}) public isDisabledExport;

  @Watch('onClearFilter')
  public changeHasFilter(value: boolean, oldValue: boolean) {
    this.title = ''
    this.titleId = ''
    this.byNotificationType = ''
    this.filterDate = []
    this.filterCreatedDate = []
  }
  public byNotificationType: string = ''
  public optionByNotification: any = [
    { value: '', text: 'Notification Type' },
    { value: 'Material', text: 'Material' },
    { value: 'Non Material', text: 'Non Material' },
  ]

  // export function
  //   public downloadCsv() {
  //     window.open(this.linkExport.link, "_blank");
  //   }

  // enable button filter
  public get enableButtonFilter() {
    if (
      this.titleOptions.length === 0 &&
      this.byNotificationType === '' &&
      this.filterDate.length === 0 &&
      this.filterCreatedDate.length === 0
    ) {
      return true
    } else {
      return false
    }
  }

  // FIlter By Title
  public title: string = ''
  public titleId: string = ''
  public titletmp: string = ''
  public byTitle(text) {
    const find = this.titleOptions.find((e) => e.name === text)
    const index = this.titleOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getTitleNotification()
    }
    if (this.titleOptions.length > 0) {
      this.titleId = this.titleOptions.find((e) => e.name === text).id
      this.titletmp = this.titleOptions.find((e) => e.name === text).name
    }
    if (this.titletmp !== text) {
      this.titleId = ''
    }
  }
  public titleOptions: any = []
  public get titleCode() {
    this.titleOptions = MasterModule.MasterData.data
    return MasterModule.MasterData
  }

  public filterDate = []
  public filterCreatedDate = []
}
